module.exports = __webpack_public_path__ + "img/Psych_text06_remember.b1abd0a7.png";